document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more');
  const readLessButtons = document.querySelectorAll('.read-less');

  readMoreButtons.forEach(function(button) {
    button.addEventListener('click', toggleDescription);
  });

  readLessButtons.forEach(function(button) {
    button.addEventListener('click', toggleDescription);
  });
});

function toggleDescription(event) {
  const button = event.currentTarget;
  const container = button.closest('.hero__description');
  const shortDesc = container.querySelector('.description-short');
  const fullDesc = container.querySelector('.description-full');
  const readMoreBtn = container.querySelector('.read-more');
  const readLessBtn = container.querySelector('.read-less');

  if (fullDesc.style.display === 'none' || fullDesc.style.display === '') {
    shortDesc.style.display = 'none';
    fullDesc.style.display = 'inline';
    readMoreBtn.style.display = 'none';
    readLessBtn.style.display = 'inline';
  } else {
    shortDesc.style.display = 'inline';
    fullDesc.style.display = 'none';
    readMoreBtn.style.display = 'inline';
    readLessBtn.style.display = 'none';
  }
}
